<template>
  <div>
    [template here]
  </div>
</template>

<script>
/*
* [name] Vue component
* ---
* [description here]
* Example usage:
*
* [example usage here]
*/

export default {
  components: {
    // register components here
  },

  mixins: [
    // mixins here
  ],

  props: {
    // props here
  },

  data () {
    return {
      // data here
    }
  },

  computed: {
    // computed here
  },

  watch: {
    // watchers
  },

  created () {
    // created here
  },

  mounted () {
    // mounted here
  },

  methods: {
    // methods here
  }
}
</script>
